import React, {useEffect,useState} from 'react'
import { FormHelperText, Box ,TextField,Grid} from "@material-ui/core";
import {useAlumno} from '../../../Context/alumnoContext'
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input/input'

export const Contacto = ({objetoModificacion,paso_cumplido,validacion,validar})=>{
    
    const [celular, setCelular] = useState(objetoModificacion.obj.celular || '')
    const [telefono, setTelefono] = useState(objetoModificacion.obj.telefono || '')
    const [avisar,setAvisar] =useState({});

   
    const changeOnblur = (e)=>{
        if(!e.target.value){
            const aux = {...avisar};
            aux[e.target.name] = true
            setAvisar(aux)
        }else{
            const aux = {...avisar};
            aux[e.target.name] = false
            setAvisar(aux)
        }
    }

useEffect(()=>{
    objetoModificacion.set({...objetoModificacion.obj,celular:celular})
},[celular])

useEffect(()=>{
    objetoModificacion.set({...objetoModificacion.obj,telefono:telefono})
},[telefono])

const checkvalidacion = (campo,validacion)=>{
  
    if (!validar) return ''

    const objetoValidacion = validacion(validar)
    
    const resultado = objetoValidacion[0];
    const texto = objetoValidacion[1]
    const campos = objetoValidacion[2]

    if(resultado==true || !(campos instanceof Array) || campos.length==0){
        return ''
    }
    if(campos.some(item=>item.campo==campo)){
        return campos.filter(item=>item.campo==campo)[0]?.texto || ''
    }else{
        return ''
    }
}

return <Box sx={{marginTop:'20px'}}>
        <h3 className='text-xl font-medium text-gray-800 mb-1'>Información de contacto</h3>
      <Grid container>
            <Grid item xs={12}>
                <div className='form-card'><div>Teléfono:<span className='c-obl'></span></div>
                    <Input
                        defaultCountry="AR"
                        id="con-telefono"
                        value={telefono}
                        placeholder="Tu respuesta"
                        maxLength="15"
                        onChange={setTelefono}/>
                    <FormHelperText className="Mui-error">{checkvalidacion('telefono',validacion)}</FormHelperText>
                </div>
            </Grid>
            <Grid item xs={12}>
                <div className='form-card'><div>Celular:<span className='c-obl'></span></div>
                    <Input
                        defaultCountry="AR"
                        id="con-celular"
                        value={celular} 
                        maxLength="15"
                        placeholder="Tu respuesta"
                        onChange={setCelular}/>
                    <FormHelperText className="Mui-error">{checkvalidacion('celular',validacion)}</FormHelperText>
                </div>
            </Grid>
        </Grid>
        <Grid container>
            <Grid item xs={12}>
                    <div className='form-card'><div>E-mail:<span className='c-obl'></span></div>
                        <TextField 
                                    onBlur={changeOnblur} 
                                    fullWidth={true} 
                                    type='text' 
                                    id='ub-email'
                                    name='email'
                                    disabled
                                    inputProps={{
                                        maxLength:100
                                    }}
                                    value={objetoModificacion.obj?.email || ''} 
                                    placeholder='Tu respuesta' 
                            />
                            <FormHelperText className="Mui-error">{checkvalidacion('email',validacion)}</FormHelperText>
                </div>
            </Grid>
        </Grid>
</Box>

}






